import React from "react";

type HeadProps = {
    pageContext: {
        locale: string
    }
}

export function Head(props: HeadProps) {
    console.log('head props', props);
    return (
        <>
            <html lang={props.pageContext.locale} />
        </>
    )
}